module.exports = __webpack_public_path__ + "img/sayings.a2baf84.webp";